import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useSelector } from "react-redux";
import { getUser } from "../../store/selectors/main";

export const PrivateRoutes = () => {
  const user = useSelector(getUser);
  return user ? <Outlet /> : <Navigate to="/sign-in" />;
};
